export default {
  setBanquetInquiryDetails: (state, response) => {
    state.banquetInquiryDetails = response;
  },
  setValue: (state, response) => {
    if (response) {
      if (typeof response.value === "object") {
        state[response.key] = { ...response.value };
      } else {
        state[response.key] = response.value;
      }
    }
  },
  setErrors: (state, error) => {
    state.errors = { ...state.errors, ...error };
  }
};
